export interface SupportedLanguage {
  code: string;
  /** Autonym — the language's name in its own language. */
  label: string;
}

export const SUPPORTED_LANGUAGES: readonly SupportedLanguage[] = [
  { code: "en", label: "English" },
  { code: "pt-BR", label: "Português" },
  { code: "es", label: "Español" },
];

const STORAGE_KEY = "labpro.language";

const isSupported = (code: string | null): code is string =>
  code != null && SUPPORTED_LANGUAGES.some((l) => l.code === code);

export const getStoredLanguage = (): string | undefined => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return isSupported(stored) ? stored : undefined;
  } catch {
    return undefined;
  }
};

export const setStoredLanguage = (code: string): void => {
  try {
    localStorage.setItem(STORAGE_KEY, code);
  } catch {
    // Persisting the preference is best-effort; a blocked storage still switches for the session.
  }
};
